module.exports = __webpack_public_path__ + "static/img/bg30.fa5826af.png";